export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 50;

export const MAX_EMAIL_LENGTH = 129;
export const MAX_EMAIL_LOCAL_PART_LENGTH = 64;
export const MAX_EMAIL_DOMAIN_PART_LENGTH = 64;

export const MAX_USERNAME = 30;
export const MAX_FORM_NAME = 50;

export const MAX_IMAGE_FILE_SIZE = 10 * 1000 * 1000; // 10 mb
export const MAX_AVATAR_IMAGE_FILE_SIZE = 5 * 1000 * 1000; // 5 mb

export const MAX_OTP_LENGTH = 6;

export const MIN_SOCIAL_LINK_LENGTH = 4;
export const MAX_SOCIAL_LINK_LENGTH = 150;

export const MAX_BIO_LENGTH = 500;

export const MAX_NAME_LENGTH = 50;

export const MAX_POST_TITLE = 140;
export const MAX_POST_DESCRIPTION = 2000;
export const MAX_GOAL_DESCRIPTION = 200;

export const MIN_DONATION_AMOUNT = 500;

export const MIN_GOAL_AMOUNT = 5;
export const MAX_GOAL_AMOUNT = 10000;
export const MAX_USD_PRICE = 250;
export const MIN_USD_PRICE = 5;
export const MATIC_DECIMAL_PART = 5;
export const USD_DECIMAL_PART = 2;

export const MAX_SUBSCRIPTION_TITLE_LENGTH = 35;
export const MAX_SUBSCRIPTION_DESCRIPTION_LENGTH = 500;
export const MAX_SUBSCRIPTION_IMAGE_SIZE = 10 * 1000 * 1000; // 10 mb

export const MAX_COMMENT_LENGTH = 500;

export const MAX_SUPPORT_MESSAGE_LENGTH = 3000;

export const MAX_MESSAGE_LENGTH = 5000;

export const MAX_COMMENT_TEXTAREA_HEIGHT = 100;

export const MAX_LIVESTREAM_TITLE_LENGTH = 140;
export const MAX_REASON_LENGTH = 1000;
export const MAX_LIVESTREAM_DESCRIPTION_LENGTH = 500;
export const MAX_LIVESTREAM_REPORT_DESCRIPTION_LENGTH = 1000;
